import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-xl text-white"></i>
              </div>
              <span className="text-xl font-heading font-bold text-white">
                爱漫画
              </span>
            </div>
            <p className="text-sm text-secondary-300 leading-relaxed">
              非常爱漫画提供免费漫画全集在线看，支持下拉式阅读。海量国漫、日漫、韩漫资源，随时随地畅享阅读乐趣。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer">
                  读者协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">漫画分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-sm text-secondary-300"></i>
                </div>
                <span className="text-sm text-secondary-300">contact@aimanhua.com</span>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-customer-service-line text-sm text-secondary-300"></i>
                </div>
                <span className="text-sm text-secondary-300">在线客服：周一至周日 9:00-21:00</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-700 text-secondary-200 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-700 text-secondary-200 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-700 text-secondary-200 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-base"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-700">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} 爱漫画 - 版权所有 | 非常爱漫画免费漫画大全
          </p>
          <p className="text-xs text-secondary-400">
            本站所有漫画均来自网络，版权归原作者所有
          </p>
        </div>
      </div>
    </footer>
  );
}